(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[764],{

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 22859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {} // Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;

  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }

  return bsDirection;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js






const defaultProps = {
  placement: 'right'
};
const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement,
  className,
  style,
  children,
  arrowProps,
  popper: _,
  show: _2,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tooltip');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Tooltip);

/***/ }),

/***/ 87144:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else { var i, n; }}(this,function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=2)}([function(t,e,n){t.exports=n(3)()},function(t,e){t.exports=__webpack_require__(67294)},function(t,e,n){"use strict";n.r(e),n.d(e,"default",function(){return f});var i=n(1),r=n.n(i),o=n(0),s=n.n(o);function a(t){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function l(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function u(t){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function c(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function p(t,e){return(p=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}var f=function(t){function e(t){var n,i,r;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e),i=this,(n=!(r=u(e).call(this,t))||"object"!==a(r)&&"function"!=typeof r?c(i):r).element=null,n.original=t.text,n.watch=!0,n.lineHeight=0,n.start=0,n.middle=0,n.end=0,n.uuid=t.id,n.state={expanded:!0,noClamp:!1,text:t.text.substring(0,20)},n.ssr="undefined"==typeof window,n.action=n.action.bind(c(n)),n.clickHandler=n.clickHandler.bind(c(n)),n.ssr?n.state.text=t.text.substring(0,20):n.debounced=n.debounce(n.action,t.delay),n}var n,o,s;return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&p(t,e)}(e,i["PureComponent"]),n=e,(o=[{key:"componentDidMount",value:function(){this.props.text&&!this.ssr&&(this.lineHeight=this.element.clientHeight+1,this.clampLines(),this.watch&&window.addEventListener("resize",this.debounced))}},{key:"componentWillUnmount",value:function(){this.ssr||window.removeEventListener("resize",this.debounced)}},{key:"componentDidUpdate",value:function(t){t.text!==this.props.text&&(this.original=this.props.text,this.clampLines())}},{key:"debounce",value:function(t,e,n){var i,r=this,o=arguments;return function(){var s=r,a=o,l=n&&!i;clearTimeout(i),i=setTimeout(function(){i=null,n||t.apply(s,a)},e),l&&t.apply(s,a)}}},{key:"action",value:function(){this.watch&&(this.setState({noClamp:!1}),this.clampLines(),this.setState({expanded:!this.state.expanded}))}},{key:"clampLines",value:function(){if(this.element){this.setState({text:""});var t=this.lineHeight*this.props.lines+1;for(this.start=0,this.middle=0,this.end=this.original.length;this.start<=this.end;){if(this.middle=Math.floor((this.start+this.end)/2),this.element.innerText=this.original.slice(0,this.middle),this.middle===this.original.length)return void this.setState({text:this.original,noClamp:!0});this.moveMarkers(t)}this.element.innerText=this.original.slice(0,this.middle-5)+this.getEllipsis(),this.setState({text:this.original.slice(0,this.middle-5)+this.getEllipsis()})}}},{key:"moveMarkers",value:function(t){this.element.clientHeight<=t?this.start=this.middle+1:this.end=this.middle-1}},{key:"getClassName",value:function(){var t=this.props.className||"";return"clamp-lines ".concat(t)}},{key:"getEllipsis",value:function(){return this.watch&&!this.state.noClamp?this.props.ellipsis:""}},{key:"getButton",value:function(){if(!this.state.noClamp&&this.props.buttons){var t=this.watch?this.props.moreText:this.props.lessText;return r.a.createElement("button",{className:"clamp-lines__button",onClick:this.clickHandler,"aria-controls":"clamped-content-".concat(this.uuid),"aria-expanded":!this.state.expanded},t)}}},{key:"clickHandler",value:function(t){var e=this.props.stopPropagation;t.preventDefault(),e&&t.stopPropagation(),this.watch=!this.watch,this.watch?this.clampLines():this.setState({text:this.original}),this.setState({expanded:!this.state.expanded})}},{key:"render",value:function(){var t=this;if(!this.props.text)return null;var e=r.a.createElement(this.props.innerElement,{ref:function(e){t.element=e},id:"clamped-content-".concat(this.uuid),"aria-hidden":this.state.expanded},this.state.text);return r.a.createElement("div",{className:this.getClassName()},e,this.getButton())}}])&&l(n.prototype,o),s&&l(n,s),e}();f.propTypes={text:s.a.string.isRequired,id:s.a.string.isRequired,lines:s.a.number,ellipsis:s.a.string,buttons:s.a.bool,moreText:s.a.string,lessText:s.a.string,className:s.a.string,delay:s.a.number,stopPropagation:s.a.bool,innerElement:s.a.string},f.defaultProps={lines:3,ellipsis:"...",buttons:!0,moreText:"Read more",lessText:"Read less",delay:300,innerElement:"div"}},function(t,e,n){"use strict";var i=n(4);function r(){}function o(){}o.resetWarningCache=r,t.exports=function(){function t(t,e,n,r,o,s){if(s!==i){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function e(){return t}t.isRequired=t;var n={array:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:o,resetWarningCache:r};return n.PropTypes=n,n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}])});

/***/ }),

/***/ 13773:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(85893),o=__webpack_require__(67294);function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=t(o),n=function(){return(n=Object.assign||function(e){for(var o,t=1,i=arguments.length;t<i;t++)for(var n in o=arguments[t])Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);return e}).apply(this,arguments)};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */function r(e,o,t){if(t||2===arguments.length)for(var i,n=0,r=o.length;n<r;n++)!i&&n in o||(i||(i=Array.prototype.slice.call(o,0,n)),i[n]=o[n]);return e.concat(i||o)}function l(o){var t=o.size,i=void 0===t?25:t,r=o.strokeColor,l=void 0===r?"none":r,a=o.storkeWidth,c=void 0===a?0:a,s=o.className,u=void 0===s?"star-svg":s,d=o.style;return e.jsx("svg",n({fill:"currentColor",width:i,height:i,viewBox:"0 0 24 24",className:u,style:n({},d)},{children:e.jsx("path",{fill:"currentColor",stroke:l,strokeMiterlimit:"10",strokeWidth:c,d:"M12,17.27L18.18,21l-1.64-7.03L22,9.24l-7.19-0.61L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27z"},void 0)}),void 0)}var a=function(){return"ontouchstart"in window||navigator.maxTouchPoints>0};function c(e,o){switch(o.type){case"PointerMove":return n(n({},e),{hoverValue:o.payload});case"PointerLeave":return{defaultValue:e.defaultValue,hoverValue:null};case"MouseClick":return n(n({},e),{defaultValue:o.payload});default:return e}}exports.i=function(t){var s,u,d=t.onClick,v=t.initialValue,f=void 0===v?0:v,p=t.ratingValue,h=void 0===p?0:p,y=t.iconsCount,m=void 0===y?5:y,g=t.size,k=void 0===g?40:g,x=t.readonly,C=void 0!==x&&x,w=t.fillColor,b=void 0===w?"#ffbc0b":w,j=t.fillColorArray,M=void 0===j?[]:j,L=t.emptyColor,V=void 0===L?"#cccccc":L,N=t.fullIcon,P=void 0===N?null:N,A=t.emptyIcon,R=void 0===A?null:A,S=t.customIcons,z=void 0===S?[]:S,I=t.rtl,O=void 0!==I&&I,T=t.allowHalfIcon,q=void 0!==T&&T,B=t.allowHover,E=void 0===B||B,F=t.transition,H=void 0!==F&&F,W=t.className,_=void 0===W?"react-simple-star-rating":W,D=t.style,X=t.fullClassName,Y=void 0===X?"filled-icons":X,G=t.emptyClassName,J=void 0===G?"empty-icons":G,K=t.fullStyle,Q=t.emptyStyle,U=t.showTooltip,Z=void 0!==U&&U,$=t.tooltipDefaultText,ee=void 0===$?"Your Rate":$,oe=t.tooltipArray,te=void 0===oe?[]:oe,ie=t.tooltipClassName,ne=void 0===ie?"react-simple-star-rating-tooltip":ie,re=t.tooltipStyle,le=o.useReducer(c,{defaultValue:h,hoverValue:null}),ae=le[0],ce=ae.defaultValue,se=ae.hoverValue,ue=le[1];i.default.useEffect((function(){return ue({type:"MouseClick",payload:h})}),[h]);var de=function(e){var o=e.clientX,t=e.currentTarget.children[0].getBoundingClientRect(),i=t.left,n=t.right,r=t.width,l=function(e,o,t){for(var i=100/e,n=t/e,r=100,l=0;l<e;l+=1)if(o<=n*l+n/4){r=0===l&&o<n/2?0:i*l;break}return r}(he,O?n-o:o-i,r);l>0&&se!==l&&ue({type:"PointerMove",payload:l})},ve=function(){se&&(ue({type:"MouseClick",payload:se}),d&&d(se))},fe=o.useMemo((function(){return Math.round(f/m*100)}),[f,m]),pe=o.useMemo((function(){return E&&se&&se||ce&&ce||fe}),[E,se,ce,fe]),he=o.useMemo((function(){return q?2*m:m}),[q,m]),ye=o.useCallback((function(e){var o=1;return e&&(o=q?e/he:e/2/10),Math.round(o-1)}),[q,he]),me=o.useCallback((function(e){return q?e/2/10:ye(e)+1}),[q,ye]),ge=function(e){return te.length>0?te[ye(e)]:me(e)||0};return e.jsxs("span",n({style:{display:"inline-block",direction:"".concat(O?"rtl":"ltr"),touchAction:"none"}},{children:[e.jsxs("span",n({className:_,style:n({position:"relative",display:"inline-block",overflow:"hidden",whiteSpace:"nowrap",cursor:C?"":"pointer",verticalAlign:"middle",userSelect:"none"},D),onPointerMove:C?void 0:de,onPointerEnter:C?void 0:function(e){a()&&de(e)},onPointerLeave:C?void 0:function(){a()&&ve(),ue({type:"PointerLeave"})},onClick:C?void 0:ve,"aria-hidden":"true"},{children:[e.jsx("span",n({className:J,style:n({display:"inline-block",color:V},Q)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||R||e.jsx(l,{size:k},i)},i)}))}),void 0),e.jsx("span",n({className:Y,style:n((s={position:"absolute",top:0},s[O?"right":"left"]=0,s.color=E&&se&&M[ye(se)]||ce&&M[ye(ce)]||b,s.overflow="hidden",s.whiteSpace="nowrap",s.display="inline-block",s.transition=H?"width .2s ease, color .2s ease":"",s.width="".concat(pe,"%"),s),K),title:"".concat(se&&me(se)||me(fe)," out of ").concat(m)},{children:r([],Array(m),!0).map((function(t,i){var n;return e.jsx(o.Fragment,{children:(null===(n=z[i])||void 0===n?void 0:n.icon)||P||e.jsx(l,{size:k},void 0)},i)}))}),void 0)]}),void 0),Z&&e.jsx("span",n({className:ne,style:n((u={display:"inline-block",padding:"5px 15px",backgroundColor:"#333",color:"#fff"},u[O?"marginRight":"marginLeft"]=20,u.verticalAlign="middle",u.borderRadius=5,u),re)},{children:se&&ge(se)||ce&&ge(ce)||fe&&ge(fe)||ee}),void 0)]}),void 0)};
//# sourceMappingURL=index.js.map


/***/ })

}]);